import { render } from "./Resource.vue?vue&type=template&id=75425471&ts=true"
import script from "./Resource.vue?vue&type=script&lang=ts&setup=true"
export * from "./Resource.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/src/PortalSite/Portal/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/resources/Resource.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75425471"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75425471', __exports__)) {
    api.reload('75425471', __exports__)
  }
  
  module.hot.accept("./Resource.vue?vue&type=template&id=75425471&ts=true", () => {
    api.rerender('75425471', render)
  })

}


export default __exports__